import React, { lazy } from 'react';
import { useLanguage } from '../LanguageContext';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
export const Testimonial = () => {
  const {
    t
  } = useLanguage();
  return <section id="testimonial" className="py-24 bg-white" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-171">
            {t.testimonial.title}
          </h2>
          <p className="text-lg text-slate-600" data-id="element-172">{t.testimonial.subtitle}</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto bg-slate-50 rounded-[2.5rem] p-8 md:p-14 shadow-sm border border-slate-100 text-center" data-id="element-173">
          <Quote size={56} className="text-indigo-200 mx-auto mb-6" fill="currentColor" data-id="element-174" />

          <div className="flex gap-1 mb-6 justify-center" data-id="element-175">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} size={22} className="text-amber-400" fill="currentColor" data-id="element-176" />)}
          </div>

          <blockquote className="text-xl md:text-2xl font-medium text-slate-800 leading-relaxed mb-8" data-id="element-177">
            {t.testimonial.quote}
          </blockquote>

          <div className="flex items-center justify-center gap-4" data-id="element-178">
            <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-sm" data-id="element-179">
              <img src="https://cdn.magicpatterns.com/uploads/1Tgvi3ncUatVLtjM2dDb2M/DSC_9203_-_square_2000x2000_(1).png" alt="Justus" width={48} height={48} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-180" />
            </div>
            <div className="text-left" data-id="element-181">
              <div className="font-bold text-slate-900" data-id="element-182">
                {t.testimonial.name}
              </div>
              <div className="text-sm text-slate-500" data-id="element-183">{t.testimonial.role}</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};